import React from 'react'
import { api } from '@api/index'
import AdminSidebar from '@components/admin/AdminSidebar'
import MessageModal from '@components/shared/MessageModal'
import useModal from '@hooks/useModal'
import { Message } from '@utils/message'
import { FieldValues, FormProvider, useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import 'twin.macro'
import AdminPostForm from '@components/admin/AdminPostForm'

const AdminNoticeAdd = () => {
  const [openResModal] = useModal()
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate(-1)
  }

  const methods = useForm({
    mode: 'onChange',
  })

  const { handleSubmit } = methods

  const createNoticeMutation = useMutation(
    ({ title, content, startDate, endDate }: FieldValues) =>
      api.adminService.createNotice(title, content, startDate, endDate)
  )

  const handleSaveClick = (form: FieldValues) => {
    createNoticeMutation.mutate(form, {
      onSuccess: async () => {
        await openResModal(
          <MessageModal>{Message.info.SUCCESS_CREATE_NOTICE}</MessageModal>
        )
        navigate('/admin/notice-management')
      },
      onError: async (err) => {
        openResModal(<MessageModal errorData={err} />)
      },
    })
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleSaveClick)}>
          <section tw="w-1200 flex gap-32">
            <AdminSidebar />
            <main tw="w-full ">
              <h1 tw="text-2xl border-b-2 font-bold pb-10 mb-20 border-neutral-400">
                공지사항 추가
              </h1>
              <div tw="w-full px-2 py-3">
                <AdminPostForm />
                <div tw="w-full flex justify-end my-15 gap-12">
                  <button
                    onClick={handleBackClick}
                    form="user-modify-form"
                    type="button"
                    tw="py-4 px-20"
                    className="button"
                  >
                    뒤로가기
                  </button>
                  <button type="submit" tw="py-4 px-20" className="button">
                    저장
                  </button>
                </div>
              </div>
            </main>
          </section>
        </form>
      </FormProvider>
    </>
  )
}

export default AdminNoticeAdd
